/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { ListCell, Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabel, useLabels } from '@/wpt-lib/pdf/useData';

const SubjectDelivery = ({
    lookupSubject,
    lookupSubjectCode,
    teachingSubjectCourseType,
    subjectActivities,
    otherTeachingActivities,
    expectNumberOfStudent,
}: Partial<{
    lookupSubject: string;
    lookupSubjectCode: string;
    teachingSubjectCourseType: string;
    subjectActivities: Record<string, boolean>;
    otherTeachingActivities: Record<string, boolean>;
    expectNumberOfStudent: string;
}>) => {
    const activitiesLabels = useLabels('subjectActivities');
    const otherActivitiesLabels = useLabels('otherTeachingActivities');

    return (
        <>
            <Row widths={[30, 70]}>
                <ValueCell
                    single
                    label="Type of subject or course"
                    value={useLabel('teachingSubjectCourseType', teachingSubjectCourseType ?? '')}
                />
                <ValueCell single label="Subject" value={`${lookupSubjectCode || ''} ${lookupSubject || ''}`} />
            </Row>
            <Row>
                <ListCell
                    single
                    label="Subject Activities"
                    values={Object.entries(subjectActivities ?? {})
                        .filter(([, v]) => v)
                        .map(([k]) => activitiesLabels[k] ?? k)}
                />
                <ListCell
                    single
                    label="Other Teaching Activities"
                    values={Object.entries(otherTeachingActivities ?? {})
                        .filter(([, v]) => v)
                        .map(([k]) => otherActivitiesLabels[k] ?? k)}
                />
            </Row>
            <Row>
                <ValueCell single label="Expected number of Students" value={expectNumberOfStudent} />
            </Row>
        </>
    );
};

export default SubjectDelivery;
